import { gql } from "@apollo/client";

export const USER_QUESTIONNAIRE_REPORT_QUERY = gql`
  query UserQuestionnaireReport {
    userQuestionnaireReport {
      hasAnswers
      submittedAt
      additionalInformation
      submissionId
      userQuestions {
        id
        question {
          text
        }
        answerText
        answerScore
      }
    }
  }
`;

export const QUESTIONNAIRE_QUERY = gql`
  query QuestionnaireQuery {
    questions {
      id
      text
      presentationSection
      answerConfig {
        id
        answer0
        answer1
        answer2
        answer3
      }
    }
    userSubmission {
      id
      questionnaireDate
      partial
      complete
      answers {
        id
        question {
          id
        }
        answer
      }
    }
  }
`;

export const SUBMIT_USER_ANSWER_MUTATION = gql`
  mutation SubmitUserAnswerMutation($input: SubmitUserAnswerMutationInput!) {
    submitUserAnswerMutation(input: $input) {
      errors {
        field
        messages
      }
    }
  }
`;

export const SUBMIT_USER_QUESTIONNAIRE_MUTATION = gql`
  mutation SubmitUserQuestionnaireMutation($input: SubmitUserQuestionnaireMutationInput!) {
    submitUserQuestionnaireMutation(input: $input) {
      errors {
        field
        messages
      }
    }
  }
`;

export const CREATE_USER_SUBMISSION_MUTATION = gql`
  mutation CreateUserSubmissionMutation($input: CreateUserSubmissionMutationInput!) {
    createUserSubmissionMutation(input: $input) {
      submissionId
      errors {
        field
        messages
      }
    }
  }
`;
